export const AP_FOOTER_LOADER = {
  desktop: `
  <div class="cui cui-grid cui-container">
    <div class="-spacing--top-80" style="margin-bottom: 72px; display: flex; gap: 6rem">
      <div class="cui-skeleton-heading -size--large -resolution--desktop" style="width: 188px">
        <div class="cui-skeleton-heading__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 100%"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -resolution--desktop" style="width: 188px">
        <div class="cui-skeleton-heading__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 100%"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block" style="margin-left: auto">
        <div class="cui-skeleton__item" style="width: 184px; height: 24px"></div>
      </div>
    </div>
    <div class="-spacing--bottom-64" style="display: flex; justify-content: space-between">
      <div style="display: flex; flex-direction: column; justify-content: end">
        <div class="cui-skeleton-button -size--small">
          <div class="cui-skeleton-button__content" style="width: 174px">
            <div class="cui-skeleton__item cui-skeleton-button__button"></div>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 32px; margin-top: 40px">
          <div class="cui-skeleton-rectangle -is--block" style="margin-right: 56px">
            <div class="cui-skeleton__item" style="width: 82px; height: 26px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 26px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 26px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 26px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 26px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 26px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 26px"></div>
          </div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 91px; height: 120px"></div>
      </div>
    </div>
  </div>`,
  mobile: `
  <div class="cui cui-grid cui-container">
    <div class="-spacing--top-32" style="display: flex; gap: 3rem; flex-direction: column">
      <div class="cui-skeleton-heading -size--large -resolution--mobile" style="width: 188px">
        <div class="cui-skeleton-heading__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 100%"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
        </div>
      </div>
      <div class="cui-skeleton-heading -size--large -resolution--mobile" style="width: 188px">
        <div class="cui-skeleton-heading__content" style="width: 100%">
          <div class="cui-skeleton__item cui-skeleton-heading__title" style="width: 100%"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
          <div class="cui-skeleton__item cui-skeleton__description" style="height: 16px"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 32px"></div>
      </div>
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 174px; height: 32px"></div>
      </div>
    </div>
    <div class="-spacing--bottom-32 -spacing--top-24" style="display: flex; justify-content: space-between; gap: 32px; align-items: end">
      <div>
        <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 6px">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 20px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 20px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 20px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 20px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 20px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 60px; height: 20px"></div>
          </div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
          <div class="cui-skeleton__item" style="width: 82px; height: 26px"></div>
        </div>
      </div>
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-12">
        <div class="cui-skeleton__item" style="width: 50px; height: 66px"></div>
      </div>
    </div>
  </div>
  `
};
